import { render, staticRenderFns } from "./CaseDetailFast.vue?vue&type=template&id=27271a04&scoped=true"
import script from "./CaseDetailFast.vue?vue&type=script&lang=js"
export * from "./CaseDetailFast.vue?vue&type=script&lang=js"
import style0 from "./CaseDetailFast.vue?vue&type=style&index=0&id=27271a04&prod&scoped=true&lang=css"
import style1 from "./CaseDetailFast.vue?vue&type=style&index=1&id=27271a04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27271a04",
  null
  
)

export default component.exports